import {
	Container,
	DividerLine,
	GrandChartButton,
	Logotype,
	NameInstrument,
	VideoWatch,
} from "./GrandChartItem.styled";
import { GrandChartStore } from "../../../stores/grand-charts/grand-chart.store";
import { getIconInstrument } from "../../../helpers";
import { IconGrandChart, IconWatchVideo } from "../../../components/common/Icons";
import { MouseEvent } from "react";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { Status } from "./Status/Status";
import { AutoRenew } from "./AutoRenew/AutoRenew";
import { ChoosePlanModal, ConfirmCancelPlanModal } from "../../../components";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { getGrandChartRoute } from "../../../helpers/grandChart/grandChart.helper";

interface GrandChartItemProps {
	grandChart: GrandChartStore;
	isPack?: boolean;
	isPreCourse?: boolean;
	withoutBorderBottom?: boolean;
}

export const GrandChartItem = observer(
	({ grandChart, isPack, isPreCourse = false, withoutBorderBottom = false }: GrandChartItemProps) => {
		const { grandCharts } = useStores();
		const navigate = useNavigate();
		const location = useLocation();

		const { t } = useTranslation();

		const { instrument } = grandChart;

		const handleOnGrandChart = async (e: MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
			e.stopPropagation();
			e.preventDefault();

			// Переходим на гранд чарт
			navigate(getGrandChartRoute(location.pathname, grandChart.id));

			// Регистрируем выбранный гранд чарт
			grandCharts.setSelected(grandChart);

			// Открываем гранд чарт
			grandCharts.modal.open();
		};

		const handleOnDetailGrandChart = async () => {
			console.log("randChart.isExistVideo", grandChart.isExistVideo);

			if (!grandChart.isExistVideo) {
				return;
			}

			console.log("grandChart", grandChart);

			grandCharts.setSelected(grandChart);
			await grandCharts.selected.getVideo();
			grandCharts.detailModal.open();
		};

		return (
			<>
				<Container
					$isPreCourse={isPreCourse}
					$withoutBorderBottom={withoutBorderBottom}
					theme={grandChart.service.slug}
				>
					<Logotype onClick={handleOnGrandChart}>{getIconInstrument(instrument.slug, isPreCourse)}</Logotype>
					<NameInstrument onClick={handleOnGrandChart}>
						{isPack ? grandChart.title : t(`instruments.${instrument.slug}`)}
					</NameInstrument>
					<GrandChartButton onClick={handleOnGrandChart}>
						<IconGrandChart />
					</GrandChartButton>
					<VideoWatch isExist={grandChart.isExistVideo} onClick={handleOnDetailGrandChart}>
						<IconWatchVideo />
						{t("buttons.watch_video")}
					</VideoWatch>
					<Status grandChart={grandChart} />
					<AutoRenew grandChart={grandChart} service_name={grandChart.service.slug} />
					{/*<CurrentStatus grandChart={grandChart} />*/}
					{/*<ButtonActions grandChart={grandChart} />*/}
				</Container>
				<ConfirmCancelPlanModal grandChart={grandChart} />
				<ChoosePlanModal grandChart={grandChart} />

				{!withoutBorderBottom && <DividerLine />}
			</>
		);
	},
);
